import type { IData } from '../model/IData'

export function getCouples(data: IData, personId: string) {
	return Object.values(data.couplesById)
		.filter((it) => it.maleId === personId || it.femaleId === personId)
		.toSorted((a, b) =>
			(a.marriedDate ?? '')?.localeCompare(b.marriedDate ?? ''),
		)
}
